import dayjs from "dayjs";
import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { MAIN_DATE_FORMAT } from "../constants";
import { formatDate, isMidnight } from "../helpers";
import { timezoneSelector } from "../recoil";

export const useTimezone = () => {
  const timezone = useRecoilValue(timezoneSelector);

  const curDateTimeAtTimezone = useMemo((): dayjs.Dayjs => {
    return dayjs().tz(timezone);
  }, [timezone]);

  const curDateTimeISO = useMemo((): TDateISO => {
    return curDateTimeAtTimezone.toISOString();
  }, [curDateTimeAtTimezone]);

  const formatISODate = (
    date: TDateISO,
    dateFormat: string = MAIN_DATE_FORMAT,
  ): string => {
    return formatDate({ dateISO: date, dateFormat, timezone });
  };

  const isMidnightTZ = (date: TDateISO | undefined): boolean => {
    return isMidnight(date, timezone);
  };

  const isValidTimeZone = (timeZone: string): boolean => {
    try {
      new Intl.DateTimeFormat("en-US", { timeZone });
      return true;
    } catch (e) {
      return false;
    }
  };

  return {
    formatISODate,
    isMidnightTZ,
    isValidTimeZone,
    timezone,
    curDateTimeISO,
    curDateTimeAtTimezone,
  };
};
